import axios from '@_system/axios/axios.js'
export default {
	path: '/BIStafflifecycle',
	get(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	formfield(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path+'/formfield', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	downcurrentday(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/downcurrentday', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

}